import React, { useEffect, useState } from "react";
import * as jnb from "react-bootstrap";
import IntakeEnhancement from "./IntakeEnhancement";
import NewCourse from "./NewCourse";
import CourseChangerMrgeClosure from "./CourseChangerMrgeClosure";
import { FaChartLine, FaChartPie, FaPlusSquare, FaTag, FaObjectGroup, FaTimesCircle, } from "react-icons/fa";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";

export default function ProgramIntakeTabs() {
  // Use a string state instead of an array to allow only ONE selection at a time
  const [activeTab, setActiveTab] = useState("enhance");

  const handleToggle = (id) => {
    setActiveTab(id);
  };
  const cardData = [
    {
      id: "enhance",
      title: "Intake Increase",
      icon: <FaChartLine />,
      color: "#4caf50",
    },
    {
      id: "reduction",
      title: "Intake Reduction",
      icon: <FaChartPie />,
      color: "#f44336",
    },
    {
      id: "new",
      title: "New Course",
      icon: <FaPlusSquare />,
      color: "#2196f3",
    },
    {
      id: "course",
      title: "Course Name Change",
      icon: <FaTag />,
      color: "#ff9800",
    },
    {
      id: "merger",
      title: "Merger of Courses",
      icon: <FaObjectGroup />,
      color: "#9c27b0",
    },
    {
      id: "close",
      title: "Closure of Course",
      icon: <FaTimesCircle />,
      color: "#607d8b",
    },
  ];

  const [courseData, setCourseData] = useState([]);
  function GetCourseDetails() {
    const url = `${config.url.FAC_URL}getCourseIntakeList`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true && res?.data?.list?.length > 0) {
          setCourseData(res.data.list);
        } else {
          setCourseData([]);
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }
  useEffect(() => {
    GetCourseDetails();
  }, []);
  return (
    <jnb.Container fluid className="py-4 bg-white rounded shadow-sm">
      <h5 className="mb-3 innerheader-new">
        <span> Nature of Proposed Changes</span>
      </h5>
      {/* Selector Grid */}
      <jnb.Row className="g-2 justify-content-center">
        {cardData.map((card) => {
          const isActive = activeTab === card.id;
          return (
            <jnb.Col key={card.id} xs={6} sm={4} md={3} lg={2}>
              <div
                onClick={() => handleToggle(card.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleToggle(card.id);
                  }
                }}
                className={`modern-selector ${isActive ? "active" : ""}`}
              >
                <div
                  className="icon-container"
                  style={{ color: isActive ? "#ffc107" : card.color }}
                >
                  {card.icon}
                </div>
                <div className="text-container">
                  <span className="selector-title">{card.title}</span>
                </div>
              </div>
            </jnb.Col>
          );
        })}
      </jnb.Row>

      <div className="mt-4 pt-3">
        {/* Section 1: Intake Variation */}
        {(activeTab === "enhance" || activeTab === "reduction") && (
          <div key="intake" className="animate-slide-up">
            <IntakeEnhancement type={activeTab} courseData={courseData} />
          </div>
        )}

        {/* Section 2: New Course */}
        {activeTab === "new" && (
          <div key="new" className="animate-slide-up">
            <NewCourse type={activeTab} courseData={courseData} />
          </div>
        )}
        {/* Section 3: Course Modifications */}
        {(activeTab === "course" ||
          activeTab === "merger" ||
          activeTab === "close") && (
            <div key="mod" className="animate-slide-up">
              <CourseChangerMrgeClosure
                typee={activeTab}
                courseData={courseData}
              />
            </div>
          )}
      </div>

      <style>{`
        .modern-selector {
          background: #ffffff;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 12px 8px; /* Compact padding */
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          min-height: 85px; /* Significantly reduced height */
        }

        .modern-selector:hover {
          border-color: #dee2e6;
          background: #fdfdfd;
          transform: translateY(-2px);
        }

        .modern-selector.active {
          background: #444444; 
          border-color: #444444;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        }

        .icon-container {
          font-size: 20px; /* Smaller icons */
          margin-bottom: 8px; /* Tighter spacing */
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .selector-title {
          font-size: 11px; /* Smaller font for better fit */
          font-weight: 600;
          color: #495057;
          line-height: 1.2;
        }

        .modern-selector.active .selector-title {
          color: #ffffff;
        }

        .content-section {
          background: #fff;
          border-radius: 8px;
        }

        .empty-state-container {
          background: #f8f9fa;
          border: 1px dashed #ced4da;
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .animate-slide-up {
          animation: slideUp 0.3s ease-out forwards;
        }
      `}</style>
    </jnb.Container>
  );
}
